import {
  setSelectedLocationId,
  setShowUnknownLocations,
} from '@/redux-toolkit/slice/SettingsLocationSlice';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

interface LinkUnknownLocationProps {
  pathName: string;
  locationName: string;
  locationId: string;
}

const LinkUnknownLocation: React.FC<LinkUnknownLocationProps> = ({
  pathName,
  locationName,
  locationId,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClick = (): void => {
    dispatch(setShowUnknownLocations(true));
    dispatch(setSelectedLocationId(locationId));
    navigate(pathName);
  };

  return (
    <span onClick={handleClick} className='link-style cursor-pointer'>
      {locationName}
    </span>
  );
};

export default LinkUnknownLocation;
